import { apiClient } from "@/lib/api-client";

export type UnsurPelaksanaanPendidikanData = Record<string, any>;

export type UnsurPelaksanaanPendidikanResponse = {
  datas: UnsurPelaksanaanPendidikanData;
  message: string;
};

export const fetchUnsurPelaksanaanPendidikan = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurPelaksanaanPendidikanData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurPelaksanaanPendidikanResponse>(
    `${baseUrl}/api/v1/unsur-pelaksanaan-pendidikan/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
